import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import ConvertCollectedFormDialog from 'FormsUI/components/creation/ConvertCollectedFormDialog';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { useFolderQuery } from 'FormsUI/api/dataFetchingClient/hooks/useFolderQuery';
import { FORMS_WRITE } from 'FormsUI/constants/Scopes';
import { jsx as _jsx } from "react/jsx-runtime";
const convertNonHSFormAction = {
  id: 'convert',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.table.collectedForms.actions.convertForm"
  }),
  actionGroup: 4,
  orderInActionGroup: 0,
  displayPermissions: {
    custom: ({
      crmObject,
      nonCrmObject
    }) => {
      const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
      return Boolean(nonCrmObject && nonCrmObject.type === 'DASHBOARD' && formType === FormTypes.CAPTURED);
    }
  },
  enablePermissions: {
    scopes: [FORMS_WRITE]
  },
  DisabledTooltipContent: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "permissions.disallowed"
  }),
  ModalOrPanel: ({
    crmObject,
    onClose
  }) => {
    const formGuid = getPropertyValue(crmObject, PROPERTIES.FORM_ID) || '';
    const folderId = getPropertyValue(crmObject, PROPERTIES.FOLDER_ID);
    const {
      data
    } = useFolderQuery(folderId ? String(folderId) : '');
    const originFolderId = data && getPropertyValue(data.getFolder, 'hs_folder_origin_id');
    return /*#__PURE__*/_jsx(ConvertCollectedFormDialog, {
      guid: formGuid,
      currentFolderId: originFolderId,
      onClose: onClose
    });
  }
};
export default convertNonHSFormAction;